import { render } from "./AprovarVoucher.vue?vue&type=template&id=50036920&scoped=true"
import script from "./AprovarVoucher.vue?vue&type=script&lang=js"
export * from "./AprovarVoucher.vue?vue&type=script&lang=js"

import "./AprovarVoucher.vue?vue&type=style&index=0&id=50036920&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50036920"]])

export default __exports__